import { render, staticRenderFns } from "./AccountCertificationsTable.vue?vue&type=template&id=af85ba0c&"
import script from "./AccountCertificationsTable.vue?vue&type=script&lang=js&"
export * from "./AccountCertificationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports